import { render } from "./ContactArea.vue?vue&type=template&id=6e4b18fa&scoped=true"
import script from "./ContactArea.vue?vue&type=script&lang=js"
export * from "./ContactArea.vue?vue&type=script&lang=js"

import "./ContactArea.vue?vue&type=style&index=0&id=6e4b18fa&scoped=true&lang=css"

import exportComponent from "/Users/frknalck/Desktop/MySite/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4b18fa"]])

export default __exports__